export * from './select-assistance-segment.component';
